export default __webpack_public_path__ + "static/media/games.9558af81.jpeg";